import styled from 'styled-components';

export const TrendPeriodSelect = styled.select`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  background-color: ${({ theme }) => theme.colors.White};
  border: 1px solid ${({ theme }) => theme.colors.Grey4};
  border-radius: 4px;
  padding: 6px 30px 6px 12px;
  cursor: pointer;
  white-space: nowrap;
  appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'><path d='M2.5 4.5L6 8l3.5-3.5' fill='none' stroke='%236B7280' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;

  &:hover {
    border-color: ${({ theme }) => theme.colors.PrimaryDefault};
  }

  &:focus-visible {
    outline: none;
    border-color: ${({ theme }) => theme.colors.PrimaryDefault};
  }
`;
